/**
 *  Date    : 2019/11/9
 *  Author  : Weilin
 *  Declare : 头部
 */

import React, { useEffect, useMemo, useState }  from 'react';
import {  useToggle, useRafTimeout  } from 'ahooks';
import { useLocation } from 'react-router-dom';
import { Modal, Popover, Button } from '@/components/AntD';
import { useActions, useSelector } from '@/utils/redux';
import { userLayoutConfig } from '@/business/hooks/permissions';
// import Understand from './Understand';
import { removeCookie } from '@/utils/cookie';
import { LOGO } from '@/constants/common';
import { useHistory } from 'react-router';
import { get as getStorage, put as putStorage } from '@/utils/storage';
import PackageServiceModal from './PackageServiceModal';
import ExperienceModal from './ExperienceModal';
import PhraseModal from '@/routes/pages/AI/TextToSpeech/components/phraseModal';
// import audiobookapi from '@/api/audiobookapi';

import './Header.scss';
import PAGES from '@/constants/page';
// import { message } from 'antd';

export default function Header() {
  const isText2speechPage = window.location.href.includes('ai/text2speech');
  const isProductlistPage = window.location.href.includes('ai/productlist');
  const wordsGuide = localStorage.getItem('wordsGuide');
  const actions = useActions(({ user }) => ({ user }));
  const history = useHistory();
  const { headerHeight } = userLayoutConfig();
  // const [forceVisible, setForceVisible] = useState(false);
  const { userInfo, adviserInfo, coinInfo }  = useSelector(state => state.user);
  const [openServiceModal, setOpenServiceModal] = useState(false);
  const [openNoticeModal, setOpenNoticeModal] = useState(false);
  const [judgeTrialAccountInfo, setJudgeTrialAccountInfo] = useState(null);
  const [agentInfo, setAgentInfo] = useState(null);
  const [phraseModalVisible, setPhraseModalVisible] = useState(false);
  const [showWordsGuide, setShowWordsGuide] = useState(wordsGuide);

  /** 更多选项 */
  const moreOptions = useMemo(() => [
    // {
    //   label: '账号设置',
    //   icon: 'ic-setting'
    // },
    {
      label: '退出登录',
      icon: 'ic-a-tuichu1',
      onClick: () => {
        toggle(true);
      }
    }
  ]);

  useEffect(() => {
    adviserInfo.partyId || actions.user.getAdviserInfo();
    actions.user.getCoinInfo();
    actions.user.judgeTrialAccount().then((data) => {
      setJudgeTrialAccountInfo(data || {});
    });
    actions.user.agentInfo().then((data) => {
      setAgentInfo(data || {});
    });
    const isShow = getStorage(RANK_TIP);
    if(!isShow) {
      hideRankTips();
    }
    // audiobookapi.getEmployeeIdByAdviserIdAndJobId().then(res => {
    //   if(res) {
    //     localStorage.setItem('empId', res);
    //   } else {
    //     localStorage.setItem('empId', '');
    //   }
    // });
  }, []);

  const hideRankTips = useRafTimeout(() => {
    putStorage(RANK_TIP, 1);
  }, 5000);

  // 显示弹窗
  const [showClose, { toggle }] = useToggle(false);
  const [showMore, setShowMore] = useState(false);

  function logout() {
    removeCookie();
    actions.user.logout();
  }

  function onClickPhrase() {
    setPhraseModalVisible(true);
  }

  function onContinue() {
    setShowWordsGuide('false');
    localStorage.setItem('wordsGuide', false);
    localStorage.setItem('createProductGuide', true);
    window._GuideSetState({
      createProductGuide: true
    });
  }

  return (
    <header className="layout-header" style={{ height: headerHeight }}>
      <div className="layout-header-main dis-flex flex-justify">
        <div className="header-symbol dis-flex">
          <strong className="logo" onClick={() => history.push(PAGES.LOGIN)} style={{ fontSize: '18px' }}>
            <img className="logo-pic" src={LOGO.header} />
          </strong>
          {!!userInfo.isTrial && <div className="version-mark">试用版</div>}
        </div>
        <div className="header-news">
          {/* <div className="header-news-item new-user-help" onClick={() => window.open('https://oss.5rs.me/oss/uploadfe/pdf/029a29c29267eaf41e35ea6c195b8262.pdf')}>新手教程</div> */}
          {
            isText2speechPage && judgeTrialAccountInfo?.trailAccount && <div className="header-news-item new-user-notice">
              <span>本账号为试用账号，每日最多合成有声书字数限制为5000字，（今日剩余字<span className="letter">{judgeTrialAccountInfo?.letterLeftToday || 0}</span>字）升级账号后可无限合成<span className="update" onClick={() => setOpenNoticeModal(!openNoticeModal)}>立即升级<i className="ic ic-pagination-next" /></span></span>
            </div>
          }
          {
            isText2speechPage && agentInfo?.formalAgent && <div className="header-news-item new-user-notice">
              <span>当前可合成字数：{agentInfo?.remainLetterCount || 0}</span>
            </div>
          }
          {
            isText2speechPage && <div className="header-news-item phonetic-correct" onClick={onClickPhrase}><i className="ic ic-ciku" />连读词库</div>
          }
          {
            isProductlistPage && <div className="header-news-item new-user-service" onClick={() => setOpenServiceModal(!openServiceModal)}>
              <img src="https://oss.5rs.me/oss/uploadfe/png/51c30d80cedae24d10f15606b9d50652.png" alt="" />
              <span>一站式配音服务</span>
            </div>
          }
          {/* 连读新手指引 */}
          {
            !showWordsGuide && isText2speechPage && <div className="new-feat-words-guide">
              <div className="feat-name"><i className="ic ic-ciku" />  <i className="start-icon" />连读词库</div>
              <div className="feat-notice-modal">
                <i className="arrow-up" />
                <i className="left-icon" />
                <p className="content">上线【词组连读】功能啦！你可以在这里添加需要连读的词组哦～</p>
                <div className="button-box">
                  <Button type="primary" onClick={onContinue}>我知道了</Button>
                </div>
              </div>
            </div>
          }
          {/* <div
            className="header-news-item rays-coin-num"
            onClick={() => {
              message.info(`您当前的AI能量值为：${coinInfo.coin}，若需充值请联系商务经理`);
            }}
          >{coinInfo.coin}</div> */}
          <Popover
            content={<div className="more">
              <ul className="options">
                {moreOptions.map((item, index) => <li key={index} onClick={item.onClick}>
                  <i className={`ic ${item.icon}`} />
                  <label className="text">{item.label}</label>
                </li>)}
              </ul>
            </div>}
            placement="bottomRight"
            trigger={'hover'}
            onOpenChange={setShowMore}
            overlayClassName="layout-header-popover"
          >
            <div className={`header-user ${showMore ? 'show' : ''}`}>
              <div className={`head-pic dis-flex flex-center ${adviserInfo.headUrl ? '' : 'default'}`}>
                <i className="ic ic-touxiang" />
                <img className="img" src={adviserInfo.headUrl} />
              </div>
              <label className="text-small" style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.9)' }}>{userInfo.name}</label>
              {<i className="ic ic-xiangxia" />}
            </div>
          </Popover>
        </div>

        {/* <Understand onCloseQrcode={() => setForceVisible(false)} forceVisible={forceVisible} /> */}
        <PackageServiceModal
          open={openServiceModal}
          setOpen={setOpenServiceModal}
        />
        <ExperienceModal
          open={openNoticeModal}
          onClose={() => {
            setOpenNoticeModal(false);
          }}
        />
        <Modal
          visible={showClose}
          title={'确认退出吗？'}
          className={'wtdc-modal-confirm ExitModal'}
          // okText={'退出'}
          width={480}
          onCancel={() => toggle(false)}
          onOk={logout}
          centered
        >
          {/* <div className="modal-content dis-flex col-flex">
            <div className="confirm-modal-content">退出后当前编辑的内容讲不会被保存。</div>
          </div> */}
        </Modal>
      </div>
      {
        phraseModalVisible && <PhraseModal
          phraseModalVisible={phraseModalVisible}
          changePhraseModalVisible={() => {
            setPhraseModalVisible(false);
          }}
        />
      }
    </header>
  );
}

/**
 * routerTab 展示的是隐藏的的二级路由、以及三级路由
 * 获取当前 pathname 动态路由
 * @returns {*[]}
 */
export function useActiveRouteList() {
  const { pathname } = useLocation();

  const { permissionMenus = [] } = useSelector(state => state.user.userInfo);

  const dynamicList = useSelector(state => state.common.dynamicList);

  // 匹配于当前子路由
  const matched = permissionMenus.filter(v => ~pathname.indexOf(v.path)) || [];

  // 查询当前列表隐藏的二级菜单
  const { children: childrenPermissions = [] } = matched[0] || {};

  //三级菜单
  const { children: matchedChild = [] } = matched[0] || {};
  const { children: thirdPermissions = [] }  = matchedChild.filter(v => ~pathname.indexOf(v.path))[0] || {};

  // 路由合并
  return [...childrenPermissions, ...thirdPermissions, ...dynamicList];
}

// const SYSTEM_LIST = [
//   {
//     label: 'RAYS 7.0'
//   },
//   {
//     label: 'RAYS 编辑端'
//   },
//   {
//     label: 'RAYS 作者端'
//   },
//   {
//     label: '尽调单'
//   }
// ];

const RANK_TIP = 'rankTip';